import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const getQuizImages = (status, pageNumber, pageSize) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.MANAGE.GET_QUIZ_IMAGES(status, pageNumber, pageSize)
  );
};

export default getQuizImages;
